import { createContext } from "react";

export interface IGoogleMapContext {
  map?: google.maps.Map;
}

export const GoogleMapContext = createContext<IGoogleMapContext>({});
